<template>
  <div class="cert-detail-wrap">
    <el-form class="cert-detail-form" ref="form" label-suffix="：" label-width="auto" :model="scanResult">
      <el-form-item label="企业名称">
        <el-input :value="scanResult.entname" disabled></el-input>
      </el-form-item>
      <el-form-item label="统一社会信用代码">
        <el-input :value="scanResult.uniscid" disabled></el-input>
      </el-form-item>
      <el-form-item label="经办人姓名">
        <el-input :value="scanResult.oper" disabled></el-input>
      </el-form-item>
      <el-form-item label="证书有效期">
        <el-input :value="scanResult.certOrder.certExpiry" disabled></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button class="btn" @click="submit" style="width: 100%; margin-top: 30px" :disabled="btnDisabled">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  data() {
    return {
      btnDisabled: false,
      dialog: {
        visible: false
      },
      qrimage: '',
      qrid: '',
      timer: ''
    };
  },
  computed: {
    ...mapState('frfwScan', ['scanResult'])
  },
  methods: {
    ...mapActions('frfwCert', ['applyCert']),
    async submit() {
      this.btnDisabled = true;
      try {
        await this.applyCert();
        this.btnDisabled = true;
        this.$router.push('/applyCertResult');
      } catch (err) {
        this.btnDisabled = true;
        this.$message.error(err.message);
      }
    }
  },
  created() {
    if (sessionStorage.getItem('cert-agree') != 1) {
      this.$message.error('请先同意《数字证书订户协议》');
      setTimeout(() => {
        this.$router.push('/notify');
      }, 2000);
    }
  }
};
</script>

<style lang="less" scoped>
@import url('../style/variable.less');
.cert-detail-wrap {
  .cert-detail-form {
    margin: 60px auto;
    width: 600px;
  }
}
.scan-wrap {
  text-align: center;
  .scan-img-wrap {
    width: 330px;
    margin: auto;
    position: relative;
    .scan-img {
      width: 200px;
      height: 200px;
      padding: 5px;
      border: 1px solid @border-color;
    }
    .refresh {
      position: absolute;
      bottom: 0;
      right: 0;
      color: #b9c4cf;
      font-size: 20px;
      cursor: pointer;
      span {
        font-size: 14px;
        margin-left: 5px;
      }
    }
  }
  .text {
    letter-spacing: 1px;
    line-height: 26px;
    font-size: 16px;
    span {
      color: #1779db;
    }
  }
}
</style>
